export default __webpack_public_path__ + "static/media/399.580e0eb3.png";